export const personStatus = {
  Newletter: 1,
  InvitedByEmail: 2,
  Registered: 3,
  Subscriber: 4,
  PastSubscriber: 5,
  Disabled: 6,
  Blocked: 7,
  FailingSubscriber: 8,
  AttemptedSubscriber: 9,
  SuperboxSubscriber: 10,
  PastSuperboxSubscriber: 11,
  AttemptedSuperbox: 12,
  FailingSuperbox: 13,
  Glampartner: 14,
};
